/**
 * Sostituzione in onda: cosa mostrare e per quanto.
 *
 * Non è una grafica a sé: è una **modalità dello spazio squadre** del tabellone.
 * Per questo vive qui e non in un componente: chi disegna il tabellone
 * (`ScorePanel`) ha bisogno delle costanti per far ciclare la transizione,
 * e chi legge gli eventi (`useLiveSubstitution`) delle stesse per sapere
 * quando spegnerla.
 */
import type { LiveSide } from './state'

/** Durata di un ciclo della transizione esce → entra. */
export const SUBSTITUTION_CYCLE_MS = 1500
/** Quante volte la transizione va in onda (4 × 1,5 s = 6 s in onda). */
export const SUBSTITUTION_CYCLES = 4
/** Quanto resta accesa la modalità sostituzione nel tabellone. */
export const SUBSTITUTION_TOTAL_MS = SUBSTITUTION_CYCLE_MS * SUBSTITUTION_CYCLES

export interface SubstitutionSwap {
  team: LiveSide
  /** Numero che esce (null se l'operatore non l'ha indicato). */
  out: string | null
  /** Numero che entra. */
  in: string | null
  /** Nome di chi esce, quando il roster è disponibile. */
  outName?: string | null
  /** Nome di chi entra, quando il roster è disponibile. */
  inName?: string | null
}
